(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  /* Locale-aware routes. The store runs multiple markets (Japan / EN), so a
     hardcoded "/cart/add.js" breaks on localized URLs. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var CART_URL = ROOT + "cart";
  var CART_ADD_URL = ROOT + "cart/add.js";

  var MAX_PICKS = 3;
  var picks = [];

  function on(root, selector, event, handler) {
    root.addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && root.contains(target)) handler(target, e);
    });
  }

  /* ---------------- Mood finder (03) ---------------- */
  document.querySelectorAll("[data-mood-finder]").forEach(function (root) {
    on(root, "[data-mood-btn]", "click", function (btn) {
      var mood = btn.getAttribute("data-mood");
      root.querySelectorAll("[data-mood-btn]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === btn));
      });
      root.querySelectorAll("[data-mood-why]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-mood-why") === mood);
      });
      root.querySelectorAll("[data-mood-recs]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-mood-recs") === mood);
      });
    });
  });

  /* ---------------- Lighting comparison (04) ---------------- */
  document.querySelectorAll("[data-compare]").forEach(function (root) {
    on(root, "[data-light-btn]", "click", function (btn) {
      var light = btn.getAttribute("data-light");
      root.querySelectorAll("[data-light-btn]").forEach(function (b) {
        b.setAttribute("aria-pressed", String(b === btn));
      });
      root.querySelectorAll(".cl-compare-cell[data-light]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-light") === light);
      });
      root.querySelectorAll(".cl-compare-note__text[data-light]").forEach(function (el) {
        el.toggleAttribute("data-active", el.getAttribute("data-light") === light);
      });
    });
  });

  /* ---------------- Shared helpers ---------------- */

  function formatWon(n) {
    return n.toLocaleString("ko-KR") + "원";
  }

  function computeTotal(unitPrice) {
    var n = picks.length;
    if (n === 0) return "—";
    if (n >= MAX_PICKS) return formatWon(unitPrice * (MAX_PICKS - 1));
    return formatWon(unitPrice * n);
  }

  function broadcast(promoLabel, unitPrice) {
    var n = picks.length;
    document.dispatchEvent(new CustomEvent("eeys:set:update", {
      detail: {
        count: n,
        total: computeTotal(unitPrice),
        countText: n >= MAX_PICKS
          ? MAX_PICKS + "컬러 선택 완료 · 1개 무료"
          : n + " / " + MAX_PICKS + " 선택",
        stickyNote: n === 0 ? promoLabel : n + "개 선택"
      }
    }));
  }

  function setButton(key) {
    return document.querySelector('[data-set-btn][data-color-key="' + key + '"]');
  }

  /* POWER variants emitted by the set-builder section, one JSON island per colour. */
  function variantsFor(key) {
    var node = document.querySelector('[data-variants-for="' + key + '"]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error("[color-landing] bad variant JSON for", key, e);
      return [];
    }
  }

  function addToCart(items, onDone) {
    if (!items.length) {
      onDone(new Error("NO_LINKED_PRODUCT"));
      return;
    }
    fetch(CART_ADD_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (res.ok) return res.json();
        /* Surface Shopify's real reason (sold out, unpublished, bad variant id) */
        return res.json()
          .catch(function () { return {}; })
          .then(function (body) {
            var err = new Error(body.description || body.message || "CART_ERROR");
            err.status = res.status;
            throw err;
          });
      })
      .then(function () { onDone(null); })
      .catch(onDone);
  }

  function messageFor(err) {
    if (err.message === "NO_LINKED_PRODUCT") return "담을 수 있는 상품이 없습니다";
    if (err.status === 422) return "선택하신 도수가 품절입니다";
    return "장바구니 담기에 실패했습니다";
  }

  /* ---------------- Power selection modal ---------------- */
  var modal = document.querySelector("[data-power-modal]");
  var modalRows = modal && modal.querySelector("[data-power-rows]");
  var modalError = modal && modal.querySelector("[data-power-error]");
  var modalSubmit = modal && modal.querySelector("[data-power-submit]");
  var modalTrigger = null;

  /* 도수 선택을 모달 대신 페이지에 바로 보여줍니다(글로벌과 동일한 형태).
     제출 로직이 modalRows 안의 [data-power-select] 를 읽으므로, 그 요소 자체를
     페이지의 [data-inline-powers] 로 옮기면 담기 로직은 손대지 않아도 됩니다. */
  var inlineHost = document.querySelector("[data-inline-powers]");
  var inlineMode = !!(inlineHost && modalRows);
  if (inlineMode) {
    inlineHost.appendChild(modalRows);
    if (modalError) inlineHost.appendChild(modalError);
    if (modal) modal.hidden = true;
  }

  function showModalError(message) {
    if (!modalError) return;
    modalError.textContent = message;
    modalError.hidden = false;
  }

  function clearModalError() {
    if (!modalError) return;
    modalError.hidden = true;
    modalError.textContent = "";
  }

  function buildModalRows() {
    /* 인라인 모드에서는 openModal() 을 거치지 않으므로 여기서 에러를 초기화합니다. */
    clearModalError();
    modalRows.innerHTML = "";
    var selectable = 0;

    picks.forEach(function (key) {
      var btn = setButton(key);
      var name = btn ? btn.getAttribute("data-color-name") : "";
      var hex = (btn && btn.getAttribute("data-color-hex")) || "#000";
      /* 전 도수를 다 보여주고 품절은 라벨로 알립니다. 예전엔 재고 있는 것만 넣어서
         고객이 원하는 도수가 아예 목록에 없는지, 품절인지 구분할 수 없었습니다. */
      var variants = variantsFor(key);

      var row = document.createElement("div");
      row.className = "cl-power-row";

      var swatch = document.createElement("span");
      swatch.className = "cl-power-row__swatch";
      swatch.style.background = hex;
      row.appendChild(swatch);

      var label = document.createElement("span");
      label.className = "cl-power-row__name";
      label.textContent = name;
      row.appendChild(label);

      /* 전 도수를 넣게 바뀌었으니 "담을 수 있는 도수 없음" 판정은 재고 유무로 합니다.
         (variants.length 로 보면 전부 품절이어도 0 이 아니라서 판정이 틀립니다.) */
      var hasStock = variants.some(function (v) { return v.available; });
      if (!hasStock) {
        var warn = document.createElement("span");
        warn.className = "cl-power-row__warn";
        warn.textContent = "품절 · 선택 불가";
        row.appendChild(warn);
      } else {
        selectable++;
        var select = document.createElement("select");
        select.className = "cl-power-row__select";
        select.setAttribute("data-power-select", key);
        select.setAttribute("aria-label", name + " 도수");
        /* 도수를 명시적으로 고르게 강제합니다. 예전엔 첫 도수가 자동 선택돼 있어서
           고객이 고른 적 없는 도수로 주문이 들어갈 수 있었습니다. */
        var ph = document.createElement("option");
        ph.value = "";
        ph.textContent = "도수 선택";
        ph.disabled = true;
        ph.selected = true;
        select.appendChild(ph);
        variants.forEach(function (v) {
          var opt = document.createElement("option");
          opt.value = String(v.id);
          opt.textContent = v.title + (v.available ? "" : " · 품절");
          if (!v.available) opt.disabled = true;
          select.appendChild(opt);
        });
        row.appendChild(select);
        /* 같은 컬러를 다른 도수로도 담을 수 있게 줄을 추가/삭제하는 버튼입니다.
           제출 로직이 [data-power-select] 를 전부 순회하므로 늘어난 줄은 자동으로 담깁니다.
           클릭 처리는 modalRows 위임 핸들러가 맡습니다(복제된 줄에도 그대로 동작). */
        var lineCtl = document.createElement("div");
        lineCtl.className = "cl-power-row__lines";
        var lineMinus = document.createElement("button");
        lineMinus.type = "button";
        lineMinus.setAttribute("data-power-remove", "");
        lineMinus.setAttribute("aria-label", name + " 도수 줄 삭제");
        lineMinus.textContent = "\u2212";
        /* 갓 만든 줄은 그 컬러의 유일한 줄이니 삭제를 막아둡니다.
           줄이 늘어나면 syncLineButtons() 가 다시 계산합니다. */
        lineMinus.disabled = true;
        var linePlus = document.createElement("button");
        linePlus.type = "button";
        linePlus.setAttribute("data-power-add", "");
        linePlus.setAttribute("aria-label", name + " 도수 줄 추가");
        linePlus.textContent = "+";
        lineCtl.appendChild(lineMinus);
        lineCtl.appendChild(linePlus);
        row.appendChild(lineCtl);
      }

      modalRows.appendChild(row);
    });

    modalSubmit.disabled = selectable === 0;
    if (selectable === 0 && picks.length) {
      showModalError("선택하신 컬러에 담을 수 있는 도수가 없습니다. 재고를 확인해 주세요.");
    }
  }

  function openModal(trigger) {
    if (!modal) {
      console.warn("[color-landing] power modal markup is missing — is the set builder section on this page?");
      return;
    }
    modalTrigger = trigger || null;
    clearModalError();
    buildModalRows();
    modal.hidden = false;
    document.body.classList.add("cl-modal-open");
    var firstSelect = modalRows.querySelector("select");
    if (firstSelect) firstSelect.focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove("cl-modal-open");
    if (modalTrigger) modalTrigger.focus();
    modalTrigger = null;
  }

  if (modal) {
    modal.querySelectorAll("[data-power-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) closeModal();
    });

    /* 도수 줄 추가/삭제. 추가는 그 줄을 복제해 도수만 비우고, 삭제는 같은 컬러의 줄이
       둘 이상일 때만 허용합니다(마지막 한 줄은 남겨야 그 컬러가 빠지지 않습니다). */
    function sameKeyRows(key) {
      return [].slice.call(modalRows.querySelectorAll('[data-power-select="' + key + '"]'));
    }
    function syncLineButtons() {
      [].slice.call(modalRows.querySelectorAll("[data-power-select]")).forEach(function (s) {
        var row = s.closest(".cl-power-row");
        if (!row) return;
        var rm = row.querySelector("[data-power-remove]");
        if (rm) rm.disabled = sameKeyRows(s.getAttribute("data-power-select")).length <= 1;
      });
    }
    modalRows.addEventListener("click", function (e) {
      var addBtn = e.target.closest ? e.target.closest("[data-power-add]") : null;
      var rmBtn = e.target.closest ? e.target.closest("[data-power-remove]") : null;
      if (addBtn) {
        var row = addBtn.closest(".cl-power-row");
        if (!row) return;
        var clone = row.cloneNode(true);
        var cs = clone.querySelector("[data-power-select]");
        if (cs) cs.selectedIndex = 0;
        row.parentNode.insertBefore(clone, row.nextSibling);
        syncLineButtons();
        return;
      }
      if (rmBtn && !rmBtn.disabled) {
        var r2 = rmBtn.closest(".cl-power-row");
        var s2 = r2 ? r2.querySelector("[data-power-select]") : null;
        if (!r2 || !s2) return;
        if (sameKeyRows(s2.getAttribute("data-power-select")).length <= 1) return;
        r2.remove();
        syncLineButtons();
      }
    });

    modalSubmit.addEventListener("click", function () {
      clearModalError();

      /* 도수를 고르지 않은 줄이 있으면 담기를 막고 그 줄로 데려갑니다. */
      var missing = [].slice.call(modalRows.querySelectorAll("[data-power-select]"))
        .filter(function (s) { return !s.value; });
      if (missing.length) {
        showModalError("도수를 선택해주세요");
        if (missing[0].scrollIntoView) missing[0].scrollIntoView({ block: "center" });
        missing[0].focus();
        return;
      }

      var items = [];
      modalRows.querySelectorAll("[data-power-select]").forEach(function (select) {
        items.push({ id: Number(select.value), quantity: 1 });
      });

      modalSubmit.disabled = true;
      addToCart(items, function (err) {
        modalSubmit.disabled = false;
        if (err) {
          console.error("[color-landing] add to cart failed:", err);
          showModalError(messageFor(err));
          return;
        }
        window.location.href = CART_URL;
      });
    });
  }

  /* Every "go to cart" button routes through the power modal. */
  function handleCheckout(button, scrollSelector) {
    if (!picks.length) {
      var target = document.querySelector(scrollSelector || "[data-set-builder]");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    /* 인라인 모드에서는 이미 페이지에 도수 줄이 있으니 모달을 띄우지 않고
       기존 제출 버튼을 그대로 눌러 담기 로직을 재사용합니다. */
    if (inlineMode && modalSubmit) { modalSubmit.click(); return; }
    openModal(button);
  }

  /* ---------------- Sticky CTA ----------------
     Registered BEFORE the set builder so the set builder's initial
     broadcast() actually reaches these listeners. */
  document.querySelectorAll("[data-sticky-cta]").forEach(function (root) {
    var noteEl = root.querySelector("[data-sticky-note]");
    var totalEl = root.querySelector("[data-sticky-total]");
    var button = root.querySelector("[data-sticky-button]");
    var defaultNote = noteEl ? noteEl.textContent : "";

    document.addEventListener("eeys:set:update", function (e) {
      if (noteEl) noteEl.textContent = e.detail.stickyNote || defaultNote;
      if (totalEl) totalEl.textContent = e.detail.total;
      if (button) {
        var label = e.detail.count > 0
          ? button.getAttribute("data-cart-label")
          : button.getAttribute("data-browse-label");
        if (label) button.textContent = label;
      }
    });

    if (button) {
      button.addEventListener("click", function () {
        handleCheckout(button, button.getAttribute("data-scroll-target"));
      });
    }
  });

  /* ---------------- Final CTA (closing screen) ----------------
     Was dead: the markup renders [data-cta="final"] but no handler existed,
     and pointer-events:none on the parent blocked the click entirely. */
  document.querySelectorAll('[data-cta="final"]').forEach(function (button) {
    button.addEventListener("click", function () {
      handleCheckout(button, button.getAttribute("data-scroll-target") || "[data-set-builder]");
    });
  });

  /* ---------------- Set builder (08) ---------------- */
  document.querySelectorAll("[data-set-builder]").forEach(function (root) {
    var unitPrice = parseInt(root.getAttribute("data-unit-price"), 10) || 0;
    var promoLabel = root.getAttribute("data-promo-label") || "";

    function render() {
      root.querySelectorAll("[data-set-btn]").forEach(function (btn) {
        var selected = picks.indexOf(btn.getAttribute("data-color-key")) >= 0;
        btn.setAttribute("aria-pressed", String(selected));
        var label = btn.querySelector("[data-pick-label]");
        if (label) label.textContent = selected ? "선택됨" : "선택";
      });
      var countEl = root.querySelector("[data-set-count]");
      var totalEls = root.querySelectorAll("[data-set-total]");
      var n = picks.length;
      if (countEl) {
        countEl.textContent = n >= MAX_PICKS
          ? MAX_PICKS + "컬러 선택 완료 · 1개 무료"
          : n + " / " + MAX_PICKS + " 선택";
      }
      totalEls.forEach(function (el) { el.textContent = computeTotal(unitPrice); });
      broadcast(promoLabel, unitPrice);
      /* 컬러 선택이 바뀌면 인라인 도수 줄을 다시 만듭니다. */
      if (inlineMode) buildModalRows();
    }

    on(root, "[data-set-btn]", "click", function (btn) {
      var key = btn.getAttribute("data-color-key");
      var idx = picks.indexOf(key);
      if (idx >= 0) {
        picks.splice(idx, 1);
      } else if (picks.length < MAX_PICKS) {
        picks.push(key);
      }
      render();
    });

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
